module.exports = __webpack_public_path__ + "static/media/not-serious-man.831b49f2.svg";